import { produce } from 'immer';

import {
  GET_ERROR_OMS_CONTROL_RECORDS,
  GET_OMS_CONTROL_RECORDS,
  SET_OMS_CONTROL_RECORDS,
  UPDATE_CONTROL_RECORD_DELIVERY_ADDRESS,
  UPDATE_CONTROL_RECORD_SHIPPING_ITEM_LINE,
  UPDATE_CONTROL_RECORDS,
} from '../../constants/constant_oms';

const TABLE_DATA_INIT_STATE = {
  data: [],
  rows_per_page: null,
  requested_page: 1,
  page: 1,
  total_rows: 0,
  is_fetching: false,
  error: '',
  sorted_columns: {
    created_datetime: {
      direction: 'asc'
    },
  },
};

export default function reducer(state = TABLE_DATA_INIT_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case GET_OMS_CONTROL_RECORDS: {
        const { data: { sale_ids } } = action;
        const rowsPerPage = sale_ids ? sale_ids.length : state.rows_per_page; 
        return {
          ...state,
          rows_per_page: rowsPerPage,
          is_fetching: true,
          error: '',
        };
      }
  
      case SET_OMS_CONTROL_RECORDS: {
        return {
          ...state,
          ...action.data,
          total_rows: action.data.total || state.total_rows,
          page: action.data.requested_page || state.page,
          is_fetching: false,
        };
      }
  
      case GET_ERROR_OMS_CONTROL_RECORDS: {
        return {
          ...state,
          error: action.payload,
          is_fetching: false,
        }
      }

      case UPDATE_CONTROL_RECORD_DELIVERY_ADDRESS: {
        const { payload } = action;
        const { id, data } = payload;
        const { delivery_address, delivery_note } = data;

        const transactionLine = draft.data.find(({ id: transactionLineId }) => transactionLineId === id);

        if (transactionLine) {
          transactionLine.delivery_address = delivery_address;
          transactionLine.delivery_note = delivery_note;
        }

        break;
      }

      case UPDATE_CONTROL_RECORD_SHIPPING_ITEM_LINE: {
        const { payload } = action;
        const { id, data } = payload;
        const transactionLine = draft.data.find(({ id: transactionLineId }) => transactionLineId === id);

        if (transactionLine) {
          transactionLine.oms_control_records = transactionLine.oms_control_records.map((omcr) => ({
            ...omcr,
            st_item_ship_line: data,
          }));
        }

        break;
      }

      case UPDATE_CONTROL_RECORDS: {
        const { payload } = action;

        payload.forEach(omcr => {
          const { sale_transaction_id } = omcr;
          const saleLine = draft.data.find(({ id: transactionLineId }) => transactionLineId === sale_transaction_id);

          if (!saleLine) return;

          saleLine.oms_control_records = saleLine.oms_control_records.map((saleLineOmcr) => {
            if (saleLineOmcr.id === omcr.id) return { ...saleLineOmcr, ...omcr };
            return saleLineOmcr;
          });
        });

        break;
      }
  
      default:
        return state;
    }
  });
}
